"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iCalData = exports.outlookData = exports.androidCalendarData = exports.googleCalendarData = void 0;
var googleCalendarData = {
  name: 'Google',
  icon: 'google'
};
exports.googleCalendarData = googleCalendarData;
var androidCalendarData = {
  name: 'Android',
  icon: 'android'
};
exports.androidCalendarData = androidCalendarData;
var outlookData = {
  name: 'Outlook',
  icon: 'msOutlook'
};
exports.outlookData = outlookData;
var iCalData = {
  name: 'iCal',
  icon: 'apple'
};
exports.iCalData = iCalData;